import SeoPageLayout from "@/components/SeoPageLayout";

const WystepKabaretowyKielce = () => (
  <SeoPageLayout title="Występ kabaretowy Kielce - profesjonalna rozrywka firmowa">
    <p>
      Kielce to ważne centrum targowe i biznesowe Polski. Występ kabaretowy w Kielcach to świetny sposób na urozmaicenie targów, konferencji, gali lub imprezy integracyjnej organizowanej w stolicy Świętokrzyskiego.
    </p>

    <h2 className="text-2xl font-bold text-foreground mt-10">Kabaret na targach i eventach w Kielcach</h2>
    <p>
      Kielce słyną z Targów Kielce - jednego z największych centrów wystawienniczych w Polsce. Oferujemy występy kabaretowe jako atrakcję towarzyszącą targom, konferencjom branżowym i galom wręczenia nagród. Humor dopasowujemy do branży i profilu uczestników.
    </p>

    <h2 className="text-2xl font-bold text-foreground mt-10">Gdzie występujemy w Kielcach?</h2>
    <ul className="list-disc pl-6 space-y-2">
      <li>Targi Kielce - eventy towarzyszące wystawom branżowym</li>
      <li>Hotele i centra konferencyjne - gale i bankiety firmowe</li>
      <li>Restauracje w centrum - kameralne spotkania i jubileusze</li>
      <li>Obiekty w Górach Świętokrzyskich - eventy integracyjne na łonie natury</li>
    </ul>

    <h2 className="text-2xl font-bold text-foreground mt-10">Kabaret dla firm ze Świętokrzyskiego</h2>
    <p>
      Obsługujemy firmy z całego regionu świętokrzyskiego. Niezależnie od wielkości wydarzenia - od kameralnego spotkania dla 20 osób po wielką galę dla 500 gości - zapewniamy profesjonalny występ kabaretowy na najwyższym poziomie.
    </p>
  </SeoPageLayout>
);

export default WystepKabaretowyKielce;
